export default __webpack_public_path__ + "static/B2B-award-ed98def20ff68be103a86ee59e0ed950.png";